import { render, staticRenderFns } from "./RemoveFromCart.vue?vue&type=template&id=2cdb2f1d&"
import script from "./RemoveFromCart.js?vue&type=script&lang=js&"
export * from "./RemoveFromCart.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports